import { FacebookFormLogs, FacebookFormLogsStatus, LeadGenerated } from "src/app/core/models/social-forms-configurations/facebook-form-configuration.model"
import { LeadGenDto, WebhooksBatchDto } from "src/app/infrastructure/lobby-proxy/DTOs/faceboo-batch.dto"

export function webhooksBatchDtoToFacebookFormLogs(source: WebhooksBatchDto, formId: string): FacebookFormLogs | null {
    if (!source) return null
    return {
        status: FacebookFormLogsStatus[source.status as keyof typeof FacebookFormLogsStatus],
        updated: new Date(source.updated),
        leads: source.leadgens?.filter(l => l.formId == formId).map(l => LeadGenDtoToLeadGenerated(l)) ?? [],
        payload: source.webhookPayload,
        exception: source.exception ?? null
    } as FacebookFormLogs
}

export function LeadGenDtoToLeadGenerated(source: LeadGenDto): LeadGenerated | null {
    if (!source) return null
    return {
        id: source.id,
        status: source.status,
        created: new Date(source.created),
        formId: source.formId
    } as LeadGenerated
}